<template>
  <v-card>
    <div v-if="clientName" class="client-name">{{ clientName }}</div>
    <div v-if="time">{{ time }} mins</div>
    <div v-if="techName" class="tech-name">{{ techName }}</div>
  </v-card>
</template>

<script>
export default {
  name: 'service-time',
  props: {
    clientName: null,
    time: null,
    techName: null
  }
}
</script>

<style scoped lang="scss">
  div.card {
    max-width: 300px;
    padding: 20px;
    line-height: 200%;
    font-size: 120%;
    div.client-name, div.tech-name {
      text-transform: uppercase;
    }
    div.client-name {
      color: #00adee;
    }
    div.tech-name {
      position: relative;
    }
    div.tech-name::before {
      border-top: 1px solid #00adee;
      content: "";
      margin-left: -19px;
      margin-top: 6px;
      position: absolute;
      transform: rotate(-45deg);
      transform-origin: 100% 100%;
      width: 24px;
    }
  }
</style>
